export const parseQuerystring = (str) => {
  const queryStart = str.indexOf('?');
  if (queryStart === -1) {
    return '';
  }
  const querystr = str.slice(queryStart + 1);

  const accumulator = {};
  querystr.split('&').forEach((param) => {
    const parts = param.replace(/\+/g, ' ').split('=');
    const key = parts.shift();
    const val = parts.length > 0 ? parts.join('=') : undefined;
    accumulator[key] = val;
  });
  return accumulator;
}